<template>
  <div class="base_color">
    <div id="container">
        <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>

        <div class="clause" >
            <p style=" font-weight: bold; font-size: 16px;text-align:center">授   权   书</p>
            <p style=" font-size: 16px;text-align:center">（个人征信业务）</p>
            <p style="color: #000; font-weight: bold; font-size: 12px;text-align:left;">重要提示：</p>
            <p class="distance"><span style="color: #000;font-weight:bold">尊敬的客户：为了维护您的权益，请在签署本授权书前，仔细阅读本授权书各条款（特别是黑体字条款），关注您在授权书中的权利、义务。如有任何疑问，请向经办行咨询。</span>
            <p class="distance" style="color:#000;">平顶山银行股份有限公司：</p>
            <p class="distance_50">一、本人同意并不可撤销地授权：<span style="color: #000;font-weight:bold">贵行（包括贵行各分支机构）按照国家相关规定采集并向金融信用信息基础数据库和其他经国务院征信业监督管理部门批准设立的征信机构提供本人个人信息和包括信贷信息在内的信用信息，包含但不限于本人因未及时履行合同义务产生的不良信息。</span></p>
            <p class="distance_50">二、本人同意并不可撤销地授权：<span style="color: #000;font-weight:bold">贵行（包括贵行各分支机构）根据国家有关规定，在办理涉及本人的业务时，有权通过金融信用信息基础数据库或其他经国务院征信业监督管理部门批准设立的征信机构查询、打印、保存、使用符合相关规定的本人信用报告、个人信息和包括信贷信息在内的信用信息，并用于以下用途：</span></p>
             <p class="distance_80">
                1.审核本人授信业务或用信申请，进行贷后风险管理。
            </p>
            <p class="distance_80">
               2.审核本人为他人（含自然人、法人、非法人组织）提供担保，进行贷后等风险管理。
            </p>
            <p class="distance_80">
               3.审核本人担任法定代表人、负责人、出资人、股东、实际控制人或其他关联人的法人或非法人组织（或该法人、其他非法人作为担保人）的授信和用信申请，进行相关风险管理。
            </p>
             <p class="distance_80">
               4.审核本人担任法定代表人、负责人、出资人、股东、实际控制人或其他关联人的法人、商户或非法人组织的特约商户开户申请，进行相关风险管理。
            </p>
            <p class="distance_80">
               5、用于办理业务_________________。
            </p>
            <p class="distance_50" style="color: #000;font-weight:bold">三、如果贵行超出本授权范围进行查询使用，则贵行应承担与此相关的法律责任。</p>
            <p class="distance_50" style="color: #000;font-weight:bold">四、若相关业务未获批准办理，本人同意本授权书及本人信用报告等资料由贵行留存，无须退还。</p>
            <p class="distance_50" style="color: #000;font-weight:bold">五、本授权书有效期自签署之日起至本人约定用途的授信到期或业务结清之日止。</p>
            <p class="distance_50" style="color: #000;font-weight:bold">授权人声明：贵行已依法向本人提示了相关条款（特别是黑体字条款），应本人要求对相关条款的概念、内容及法律效果做了说明，本人已经知悉并理解上述条款。</p>
            <div style="text-align:left">
                <div>授权人（签字）：</div>
                <div>曾用名（签字）：</div>
                <div>证件名称： □居民身份证 □其他</div>
                <div>证件号码：</div>

            </div>
             <div style="text-align:right">
                <div>年  月  日</div>
            </div>
        </div>
    </div>
</div>
</template>
<script>


export default {
  name: 'FeildTwo',
  data() {
    return {

    };
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
 *{
        /* width: 90%; */
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        font-size: 12px;
        }
        body{font-family: '微软雅黑'}
        .distance{
            text-align: left;

            /* margin-left: 10px; */
        }
        .distance_50{
            letter-spacing: 0;
            text-align: left;
            text-indent:6px;
        }
        .distance_80{
            text-align: left;

            /* margin-left: 10px; */
        }
        p{margin-bottom: 8px;}
    #close {
    position: fixed;
    top: 0;
    left: 0;
    box-sizing: border-box;
    width: 100%;
    height: 30px;
    padding-right: 10px;
    color: white;
    font-size: 20px;
    line-height: 30px;
    text-align: right;
    background: #3d4145;
}

</style>
